var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99691 6.01693C11.4702 6.01693 12.6636 4.82359 12.6636 3.35026C12.6636 1.87693 11.4702 0.683594 9.99691 0.683594C8.52357 0.683594 7.33024 1.87693 7.33024 3.35026C7.33024 4.82359 8.52357 6.01693 9.99691 6.01693ZM9.99691 2.01693C10.7302 2.01693 11.3302 2.61693 11.3302 3.35026C11.3302 4.08359 10.7302 4.68359 9.99691 4.68359C9.26357 4.68359 8.66357 4.08359 8.66357 3.35026C8.66357 2.61693 9.26357 2.01693 9.99691 2.01693ZM9.99691 7.35026C8.21691 7.35026 4.66357 8.24359 4.66357 10.0169L4.66357 11.3503L15.3302 11.3503L15.3302 10.0169C15.3302 8.24359 11.7769 7.35026 9.99691 7.35026ZM5.99691 10.0169C6.14357 9.53693 8.20357 8.68359 9.99691 8.68359C11.7969 8.68359 13.8636 9.54359 13.9969 10.0169L5.99691 10.0169ZM3.99691 8.01693L3.99691 6.01693L5.99691 6.01693L5.99691 4.68359L3.99691 4.68359L3.99691 2.68359L2.66357 2.68359L2.66357 4.68359L0.663574 4.68359L0.663574 6.01693L2.66357 6.01693L2.66357 8.01693L3.99691 8.01693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInviteIcon);
export default __webpack_public_path__ + "static/media/UserInviteIcon.2eee2f84.svg";
export { ForwardRef as ReactComponent };